export default __webpack_public_path__ + "static/media/selected-plan-icon.3e56a7a8.svg";